import { Container, Row, Col, Card, Badge } from "react-bootstrap";
import { FaTags, FaBolt, FaPercent } from "react-icons/fa";
import { useEffect, useState } from "react";
import { getMenuItemsRealtime } from "../utils/functionFirebase";
import { addToCart } from "../utils/functionMenu";
import { useCart } from "../utils/CartContext";
import "../style/offers.css"; // استيراد ملف الستايل الجديد
import { useLocation, useNavigate } from "react-router-dom";
import { getAuth } from "firebase/auth";

export default function Offers() {
  const [offers, setOffers] = useState([]);
  const { cart, refreshCartCount } = useCart();
  const [addedOfferId, setAddedOfferId] = useState(null);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const unsubscribe = getMenuItemsRealtime((result) => {
      if (result.success) {
        setOffers(result.data.filter(item => item.section === "offers"));
      }
    });
    return () => { if (unsubscribe) unsubscribe(); };
  }, []);

  const handleOrderNow = (offer) => {
    const auth = getAuth();
    if (!auth.currentUser) {
      // يمكنك عرض رسالة هنا إذا أردت
      navigate("/auth");
      return;
    }
    addToCart({
      id: offer.id,
      name: offer.title || offer.name,
      price: offer.newPrice || offer.price,
      img: offer.imgUrl || offer.img,
    }, cart);
    setAddedOfferId(offer.id);
    setTimeout(() => setAddedOfferId(null), 1200);
  };

  return (
    <Container className="py-5" >
      <div className="text-center mb-5">
        <FaBolt size={40} color="#ff3e3e" style={{ marginBottom: 10 }} />
        <h2 className="fw-bold" style={{ color: "#ff3e3e", letterSpacing: 2 }}>
          أقوى العروض والخصومات
        </h2>
        <p className="fs-5 text-muted">لا تفوت الفرصة! عروض لفترة محدودة فقط</p>
      </div>
      <Row className="gy-5">
        {offers.map((offer) => (
          <Col md={6} lg={4} key={offer.id}>
            <Card className="offer-card shadow-lg position-relative">
              {/* شريط خصم دائري */}
              <div className="disCount">
                <FaPercent style={{ marginLeft: 6 }} />
                خصم
              </div>
              <div className="image-container">
                <img
                  src={offer.imgUrl || offer.img}
                  alt={offer.title || offer.name}
                  className="img-item"
                />
              </div>
              <Card.Body className="text-end d-flex flex-column justify-content-between">
                <div>
                  <Card.Title className="fw-bold offer-title">
                    <FaTags style={{ marginLeft: 6 }} />
                    {offer.title || offer.name}
                  </Card.Title>
                  <Card.Text className="mb-2 offer-desc">
                    {offer.description || offer.desc}
                  </Card.Text>
                </div>
                <div className="d-flex align-items-center justify-content-between mt-3">
                  <span className="text-muted text-decoration-line-through fs-6">
                    {offer.oldPrice} د.أ
                  </span>
                  <span className="fw-bold fs-4 offer-price">
                    {offer.newPrice || offer.price} د.أ
                  </span>
                </div>
                <div className="text-center mt-3">
                  {location.pathname !== "/" && (
                    <button
                      className={`offer-order-btn w-100 ${addedOfferId === offer.id ? "added-effect" : ""}`}
                      onClick={() => handleOrderNow(offer)}
                      disabled={addedOfferId === offer.id}
                    >
                      <FaBolt style={{ marginLeft: 4 }} />
                      {addedOfferId === offer.id ? "تمت الإضافة ✅" : "اطلب الآن"}
                    </button>
                  )}
                </div>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>
    </Container>
  );
}